// GENERATED by scripts/gen-preload-surface.mjs — do not edit by hand.
// Run `node scripts/gen-preload-surface.mjs` after changing electron/preload/index.ts.

/** How a `window.api` property reaches the main process. */
export type PreloadKind =
  /** `ipcRenderer.invoke` — request/response, returns a Promise. */
  | 'invoke'
  /** `ipcRenderer.send` — fire and forget, returns void. */
  | 'send'
  /** `ipcRenderer.on` — subscription, returns an unsubscribe function. */
  | 'on'
  /** Anything else. The mobile shim must implement these by hand. */
  | 'custom'

export interface PreloadEntry {
  /** Dotted path under `window.api`, e.g. `claudeUsage.getSnapshot`. */
  path: string
  kind: PreloadKind
  /** IPC channel, or null when the property touches no single channel. */
  channel: string | null
}

export const PRELOAD_SURFACE: readonly PreloadEntry[] = [
  { path: 'agentCapabilities.get', kind: 'invoke', channel: 'agent-capabilities:get' },
  { path: 'agentCapabilities.refresh', kind: 'invoke', channel: 'agent-capabilities:refresh' },
  { path: 'appendWebhookRequest', kind: 'invoke', channel: 'append-webhook-request' },
  { path: 'applyPendingUpdate', kind: 'invoke', channel: 'apply-pending-update' },
  { path: 'authGetUser', kind: 'invoke', channel: 'auth-get-user' },
  { path: 'authLogout', kind: 'invoke', channel: 'auth-logout' },
  { path: 'authStartLogin', kind: 'invoke', channel: 'auth-start-login' },
  { path: 'browserClearLogs', kind: 'invoke', channel: 'browser-clear-logs' },
  { path: 'browserDeleteAll', kind: 'invoke', channel: 'browser-delete-all' },
  { path: 'browserLoadLogs', kind: 'invoke', channel: 'browser-load-logs' },
  { path: 'browserPickRespond', kind: 'invoke', channel: 'browser-pick-respond' },
  { path: 'browserSaveLogs', kind: 'invoke', channel: 'browser-save-logs' },
  { path: 'cancelUpdate', kind: 'invoke', channel: 'cancel-update' },
  { path: 'checkForUpdates', kind: 'invoke', channel: 'check-for-updates' },
  { path: 'checkPathsExist', kind: 'invoke', channel: 'check-paths-exist' },
  { path: 'claudeAccounts.cancelLogin', kind: 'invoke', channel: 'claudeAccounts:cancelLogin' },
  { path: 'claudeAccounts.list', kind: 'invoke', channel: 'claudeAccounts:list' },
  { path: 'claudeAccounts.login', kind: 'invoke', channel: 'claudeAccounts:login' },
  { path: 'claudeAccounts.onChanged', kind: 'on', channel: 'claudeAccounts:changed' },
  { path: 'claudeAccounts.onLoginState', kind: 'on', channel: 'claudeAccounts:loginState' },
  { path: 'claudeAccounts.remove', kind: 'invoke', channel: 'claudeAccounts:remove' },
  { path: 'claudeAccounts.resolveDuplicateLogin', kind: 'invoke', channel: 'claudeAccounts:resolveDuplicateLogin' },
  { path: 'claudeAccounts.submitCode', kind: 'invoke', channel: 'claudeAccounts:submitCode' },
  { path: 'claudeUpdateCheckNow', kind: 'invoke', channel: 'claude-update-check-now' },
  { path: 'claudeUpdateClearReconnect', kind: 'invoke', channel: 'claude-update-clear-reconnect' },
  { path: 'claudeUpdateDismiss', kind: 'invoke', channel: 'claude-update-dismiss' },
  { path: 'claudeUpdateGetState', kind: 'invoke', channel: 'claude-update-get-state' },
  { path: 'claudeUpdateInstall', kind: 'invoke', channel: 'claude-update-install' },
  { path: 'claudeUpdateManualCommand', kind: 'invoke', channel: 'claude-update-manual-command' },
  { path: 'claudeUpdateRunManualCommand', kind: 'invoke', channel: 'claude-update-run-manual-command' },
  { path: 'claudeUsage.clearHistory', kind: 'invoke', channel: 'claudeUsage:clearHistory' },
  { path: 'claudeUsage.getState', kind: 'invoke', channel: 'claudeUsage:getState' },
  { path: 'claudeUsage.onUpdate', kind: 'on', channel: 'claudeUsage:update' },
  { path: 'claudeUsage.refresh', kind: 'invoke', channel: 'claudeUsage:refresh' },
  { path: 'clearWebhookRequests', kind: 'invoke', channel: 'clear-webhook-requests' },
  { path: 'cliInstallCommand', kind: 'invoke', channel: 'cli-install-command' },
  { path: 'cliInstallGetState', kind: 'invoke', channel: 'cli-install-get-state' },
  { path: 'cliInstallStart', kind: 'invoke', channel: 'cli-install-start' },
  { path: 'clipboardPaste', kind: 'invoke', channel: 'clipboard-paste' },
  { path: 'cliUpdateCheckNow', kind: 'invoke', channel: 'cli-update-check-now' },
  { path: 'cliUpdateClearReconnect', kind: 'invoke', channel: 'cli-update-clear-reconnect' },
  { path: 'cliUpdateDismiss', kind: 'invoke', channel: 'cli-update-dismiss' },
  { path: 'cliUpdateGetAll', kind: 'invoke', channel: 'cli-update-get-all' },
  { path: 'cliUpdateGetState', kind: 'invoke', channel: 'cli-update-get-state' },
  { path: 'cliUpdateInstall', kind: 'invoke', channel: 'cli-update-install' },
  { path: 'cliUpdateManualCommand', kind: 'invoke', channel: 'cli-update-manual-command' },
  { path: 'cliUpdateRunManualCommand', kind: 'invoke', channel: 'cli-update-run-manual-command' },
  { path: 'cliWrapperInstall', kind: 'invoke', channel: 'cli-wrapper-install' },
  { path: 'cliWrapperStatus', kind: 'invoke', channel: 'cli-wrapper-status' },
  { path: 'cliWrapperUninstall', kind: 'invoke', channel: 'cli-wrapper-uninstall' },
  { path: 'closeUsagePin', kind: 'invoke', channel: 'usage-pin:close' },
  { path: 'closeWindow', kind: 'send', channel: 'close-window' },
  { path: 'codexAccounts.cancelLogin', kind: 'invoke', channel: 'codexAccounts:cancelLogin' },
  { path: 'codexAccounts.getSelected', kind: 'invoke', channel: 'codexAccounts:getSelected' },
  { path: 'codexAccounts.list', kind: 'invoke', channel: 'codexAccounts:list' },
  { path: 'codexAccounts.login', kind: 'invoke', channel: 'codexAccounts:login' },
  { path: 'codexAccounts.onChanged', kind: 'on', channel: 'codexAccounts:changed' },
  { path: 'codexAccounts.onLoginState', kind: 'on', channel: 'codexAccounts:loginState' },
  { path: 'codexAccounts.remove', kind: 'invoke', channel: 'codexAccounts:remove' },
  { path: 'codexAccounts.resolveDuplicateLogin', kind: 'invoke', channel: 'codexAccounts:resolveDuplicateLogin' },
  { path: 'codexAccounts.setSelected', kind: 'invoke', channel: 'codexAccounts:setSelected' },
  { path: 'codexStats.discoverAgents', kind: 'invoke', channel: 'codexStats:discoverAgents' },
  { path: 'codexStats.get', kind: 'invoke', channel: 'codexStats:get' },
  { path: 'codexStats.getProject', kind: 'invoke', channel: 'codexStats:getProject' },
  { path: 'convertSlashCommandToSkill', kind: 'invoke', channel: 'convert-slash-command-to-skill' },
  { path: 'copyPath', kind: 'invoke', channel: 'copy-path' },
  { path: 'createClaudeSession', kind: 'invoke', channel: 'create-claude-session' },
  { path: 'createCodexSession', kind: 'invoke', channel: 'create-codex-session' },
  { path: 'createFile', kind: 'invoke', channel: 'create-file' },
  { path: 'createFolder', kind: 'invoke', channel: 'create-folder' },
  { path: 'createGeminiSession', kind: 'invoke', channel: 'create-gemini-session' },
  { path: 'createGrokSession', kind: 'invoke', channel: 'create-grok-session' },
  { path: 'createKimiSession', kind: 'invoke', channel: 'create-kimi-session' },
  { path: 'createNote', kind: 'invoke', channel: 'create-note' },
  { path: 'createTerminal', kind: 'invoke', channel: 'create-terminal' },
  { path: 'deleteCodexSession', kind: 'invoke', channel: 'delete-codex-session' },
  { path: 'deleteFolder', kind: 'invoke', channel: 'delete-folder' },
  { path: 'deleteGeminiSession', kind: 'invoke', channel: 'delete-gemini-session' },
  { path: 'deleteGrokSession', kind: 'invoke', channel: 'delete-grok-session' },
  { path: 'deleteKimiSession', kind: 'invoke', channel: 'delete-kimi-session' },
  { path: 'deleteNote', kind: 'invoke', channel: 'delete-note' },
  { path: 'deleteProject', kind: 'invoke', channel: 'delete-project' },
  { path: 'deleteProjectIconImage', kind: 'invoke', channel: 'delete-project-icon-image' },
  { path: 'deleteRequestData', kind: 'invoke', channel: 'delete-request-data' },
  { path: 'deleteTempImage', kind: 'invoke', channel: 'delete-temp-image' },
  { path: 'deleteTerminal', kind: 'invoke', channel: 'delete-terminal' },
  { path: 'deleteTerminalHistory', kind: 'invoke', channel: 'delete-terminal-history' },
  { path: 'deleteWebhookState', kind: 'invoke', channel: 'delete-webhook-state' },
  { path: 'detectPorts', kind: 'invoke', channel: 'detect-ports' },
  { path: 'devtoolsDisableNetwork', kind: 'invoke', channel: 'devtools-disable-network' },
  { path: 'devtoolsEnableNetwork', kind: 'invoke', channel: 'devtools-enable-network' },
  { path: 'devtoolsGetCookies', kind: 'invoke', channel: 'devtools-get-cookies' },
  { path: 'devtoolsGetResourceContent', kind: 'invoke', channel: 'devtools-get-resource-content' },
  { path: 'devtoolsGetResourceTree', kind: 'invoke', channel: 'devtools-get-resource-tree' },
  { path: 'devtoolsGetResponseBody', kind: 'invoke', channel: 'devtools-get-response-body' },
  { path: 'discoverAgents', kind: 'invoke', channel: 'discover-agents' },
  { path: 'dismissUpdateVersion', kind: 'invoke', channel: 'dismiss-update-version' },
  { path: 'editorUpdateActiveFile', kind: 'invoke', channel: 'editor-update-active-file' },
  { path: 'editorUpdateOpenFiles', kind: 'invoke', channel: 'editor-update-open-files' },
  { path: 'editorUpdateSelection', kind: 'invoke', channel: 'editor-update-selection' },
  { path: 'editorUpdateSelections', kind: 'invoke', channel: 'editor-update-selections' },
  { path: 'editorUpdateSplitView', kind: 'invoke', channel: 'editor-update-split-view' },
  { path: 'editorUpdateWorkspaces', kind: 'invoke', channel: 'editor-update-workspaces' },
  { path: 'ensureAppsAuth', kind: 'invoke', channel: 'ensure-apps-auth' },
  { path: 'geminiAccounts.addApiKey', kind: 'invoke', channel: 'geminiAccounts:addApiKey' },
  { path: 'geminiAccounts.cancelLogin', kind: 'invoke', channel: 'geminiAccounts:cancelLogin' },
  { path: 'geminiAccounts.getSelected', kind: 'invoke', channel: 'geminiAccounts:getSelected' },
  { path: 'geminiAccounts.list', kind: 'invoke', channel: 'geminiAccounts:list' },
  { path: 'geminiAccounts.login', kind: 'invoke', channel: 'geminiAccounts:login' },
  { path: 'geminiAccounts.onChanged', kind: 'on', channel: 'geminiAccounts:changed' },
  { path: 'geminiAccounts.onLoginState', kind: 'on', channel: 'geminiAccounts:loginState' },
  { path: 'geminiAccounts.remove', kind: 'invoke', channel: 'geminiAccounts:remove' },
  { path: 'geminiAccounts.resolveDuplicateLogin', kind: 'invoke', channel: 'geminiAccounts:resolveDuplicateLogin' },
  { path: 'geminiAccounts.setSelected', kind: 'invoke', channel: 'geminiAccounts:setSelected' },
  { path: 'geminiAccounts.submitCode', kind: 'invoke', channel: 'geminiAccounts:submitCode' },
  { path: 'geminiStats.discoverAgents', kind: 'invoke', channel: 'geminiStats:discoverAgents' },
  { path: 'geminiStats.get', kind: 'invoke', channel: 'geminiStats:get' },
  { path: 'geminiStats.getProject', kind: 'invoke', channel: 'geminiStats:getProject' },
  { path: 'generateCommitMessage', kind: 'invoke', channel: 'generate-commit-message' },
  { path: 'getAgentMcpServers', kind: 'invoke', channel: 'get-agent-mcp-servers' },
  { path: 'getAppVersion', kind: 'invoke', channel: 'get-app-version' },
  { path: 'getAutoUpdate', kind: 'invoke', channel: 'get-auto-update' },
  { path: 'getBootState', kind: 'invoke', channel: 'get-boot-state' },
  { path: 'getClaudeCleanupPeriod', kind: 'invoke', channel: 'get-claude-cleanup-period' },
  { path: 'getClaudeMessageContext', kind: 'invoke', channel: 'get-claude-message-context' },
  { path: 'getCodexSessions', kind: 'invoke', channel: 'get-codex-sessions' },
  { path: 'getEventLoopReport', kind: 'invoke', channel: 'diagnostics:event-loop' },
  { path: 'getFileMediaType', kind: 'invoke', channel: 'get-file-media-type' },
  { path: 'getFolders', kind: 'invoke', channel: 'get-folders' },
  { path: 'getGeminiSessions', kind: 'invoke', channel: 'get-gemini-sessions' },
  { path: 'getGitIgnored', kind: 'invoke', channel: 'get-git-ignored' },
  { path: 'getGrokSessions', kind: 'invoke', channel: 'get-grok-sessions' },
  { path: 'getInstalledPackages', kind: 'invoke', channel: 'get-installed-packages' },
  { path: 'getIsDev', kind: 'invoke', channel: 'get-is-dev' },
  { path: 'getKimiSessions', kind: 'invoke', channel: 'get-kimi-sessions' },
  { path: 'getMcpRecommendationSkipped', kind: 'invoke', channel: 'get-mcp-recommendation-skipped' },
  { path: 'getMcpServers', kind: 'invoke', channel: 'get-mcp-servers' },
  { path: 'getMcpVersions', kind: 'invoke', channel: 'get-mcp-versions' },
  { path: 'getMobileEnabled', kind: 'invoke', channel: 'get-mobile-enabled' },
  { path: 'getNotes', kind: 'invoke', channel: 'get-notes' },
  { path: 'getPathForFile', kind: 'custom', channel: null },
  { path: 'getPendingSelections', kind: 'invoke', channel: 'get-pending-selections' },
  { path: 'getProjectIconDataUrl', kind: 'invoke', channel: 'get-project-icon-data-url' },
  { path: 'getProjectIconPath', kind: 'invoke', channel: 'get-project-icon-path' },
  { path: 'getProjectIconSourceDataUrl', kind: 'invoke', channel: 'get-project-icon-source-data-url' },
  { path: 'getProjects', kind: 'invoke', channel: 'get-projects' },
  { path: 'getPtyRecentExit', kind: 'invoke', channel: 'get-pty-recent-exit' },
  { path: 'getRegistryMcp', kind: 'invoke', channel: 'get-registry-mcp' },
  { path: 'getRegistryMcps', kind: 'invoke', channel: 'get-registry-mcps' },
  { path: 'getRegistryPackage', kind: 'invoke', channel: 'get-registry-package' },
  { path: 'getRegistryPackages', kind: 'invoke', channel: 'get-registry-packages' },
  { path: 'getRegistrySkill', kind: 'invoke', channel: 'get-registry-skill' },
  { path: 'getRegistrySkills', kind: 'invoke', channel: 'get-registry-skills' },
  { path: 'getRelayHost', kind: 'invoke', channel: 'relay-get-host' },
  { path: 'getSessionConversation', kind: 'invoke', channel: 'get-session-conversation' },
  { path: 'getSetting', kind: 'invoke', channel: 'get-setting' },
  { path: 'getSidebarApps', kind: 'invoke', channel: 'get-sidebar-apps' },
  { path: 'getSkills', kind: 'invoke', channel: 'get-skills' },
  { path: 'getSlashCommands', kind: 'invoke', channel: 'get-slash-commands' },
  { path: 'getSupabaseAccessToken', kind: 'invoke', channel: 'supabase-access-token' },
  { path: 'getSyncStatus', kind: 'invoke', channel: 'get-sync-status' },
  { path: 'getTabs', kind: 'invoke', channel: 'get-tabs' },
  { path: 'getTerminals', kind: 'invoke', channel: 'get-terminals' },
  { path: 'getUiState', kind: 'invoke', channel: 'get-ui-state' },
  { path: 'getUpdateChannel', kind: 'invoke', channel: 'get-update-channel' },
  { path: 'getUsagePinContext', kind: 'invoke', channel: 'usage-pin:get-context' },
  { path: 'ghListRepos', kind: 'invoke', channel: 'gh-list-repos' },
  { path: 'gitBranches', kind: 'invoke', channel: 'git-branches' },
  { path: 'gitCheckoutBranch', kind: 'invoke', channel: 'git-checkout-branch' },
  { path: 'gitClone', kind: 'invoke', channel: 'git-clone' },
  { path: 'gitCommit', kind: 'invoke', channel: 'git-commit' },
  { path: 'gitCreateBranch', kind: 'invoke', channel: 'git-create-branch' },
  { path: 'gitDiff', kind: 'invoke', channel: 'git-diff' },
  { path: 'gitDiffAll', kind: 'invoke', channel: 'git-diff-all' },
  { path: 'gitDiscard', kind: 'invoke', channel: 'git-discard' },
  { path: 'gitFetch', kind: 'invoke', channel: 'git-fetch' },
  { path: 'gitIsRepo', kind: 'invoke', channel: 'git-is-repo' },
  { path: 'gitLog', kind: 'invoke', channel: 'git-log' },
  { path: 'gitMerge', kind: 'invoke', channel: 'git-merge' },
  { path: 'gitPull', kind: 'invoke', channel: 'git-pull' },
  { path: 'gitPush', kind: 'invoke', channel: 'git-push' },
  { path: 'gitShow', kind: 'invoke', channel: 'git-show' },
  { path: 'gitShowFiles', kind: 'invoke', channel: 'git-show-files' },
  { path: 'gitStage', kind: 'invoke', channel: 'git-stage' },
  { path: 'gitStageAll', kind: 'invoke', channel: 'git-stage-all' },
  { path: 'gitStashList', kind: 'invoke', channel: 'git-stash-list' },
  { path: 'gitStashPop', kind: 'invoke', channel: 'git-stash-pop' },
  { path: 'gitStashSave', kind: 'invoke', channel: 'git-stash-save' },
  { path: 'gitStats.get', kind: 'invoke', channel: 'gitStats:get' },
  { path: 'gitStatus', kind: 'invoke', channel: 'git-status' },
  { path: 'gitUnstage', kind: 'invoke', channel: 'git-unstage' },
  { path: 'gitUnstageAll', kind: 'invoke', channel: 'git-unstage-all' },
  { path: 'gitWorktreeAdd', kind: 'invoke', channel: 'git-worktree-add' },
  { path: 'gitWorktreeList', kind: 'invoke', channel: 'git-worktree-list' },
  { path: 'gitWorktreeRemove', kind: 'invoke', channel: 'git-worktree-remove' },
  { path: 'grokAccounts.cancelLogin', kind: 'invoke', channel: 'grokAccounts:cancelLogin' },
  { path: 'grokAccounts.getSelected', kind: 'invoke', channel: 'grokAccounts:getSelected' },
  { path: 'grokAccounts.list', kind: 'invoke', channel: 'grokAccounts:list' },
  { path: 'grokAccounts.login', kind: 'invoke', channel: 'grokAccounts:login' },
  { path: 'grokAccounts.onChanged', kind: 'on', channel: 'grokAccounts:changed' },
  { path: 'grokAccounts.onLoginState', kind: 'on', channel: 'grokAccounts:loginState' },
  { path: 'grokAccounts.remove', kind: 'invoke', channel: 'grokAccounts:remove' },
  { path: 'grokAccounts.resolveDuplicateLogin', kind: 'invoke', channel: 'grokAccounts:resolveDuplicateLogin' },
  { path: 'grokAccounts.setSelected', kind: 'invoke', channel: 'grokAccounts:setSelected' },
  { path: 'grokStats.discoverAgents', kind: 'invoke', channel: 'grokStats:discoverAgents' },
  { path: 'grokStats.get', kind: 'invoke', channel: 'grokStats:get' },
  { path: 'grokStats.getProject', kind: 'invoke', channel: 'grokStats:getProject' },
  { path: 'installMcp', kind: 'invoke', channel: 'install-mcp' },
  { path: 'installPackage', kind: 'invoke', channel: 'install-package' },
  { path: 'installSkill', kind: 'invoke', channel: 'install-skill' },
  { path: 'isMaximized', kind: 'invoke', channel: 'is-maximized' },
  { path: 'isUsagePinOpen', kind: 'invoke', channel: 'usage-pin:is-open' },
  { path: 'killClaudeSession', kind: 'invoke', channel: 'kill-claude-session' },
  { path: 'kimiAccounts.cancelLogin', kind: 'invoke', channel: 'kimiAccounts:cancelLogin' },
  { path: 'kimiAccounts.getSelected', kind: 'invoke', channel: 'kimiAccounts:getSelected' },
  { path: 'kimiAccounts.list', kind: 'invoke', channel: 'kimiAccounts:list' },
  { path: 'kimiAccounts.login', kind: 'invoke', channel: 'kimiAccounts:login' },
  { path: 'kimiAccounts.onChanged', kind: 'on', channel: 'kimiAccounts:changed' },
  { path: 'kimiAccounts.onLoginState', kind: 'on', channel: 'kimiAccounts:loginState' },
  { path: 'kimiAccounts.remove', kind: 'invoke', channel: 'kimiAccounts:remove' },
  { path: 'kimiAccounts.resolveDuplicateLogin', kind: 'invoke', channel: 'kimiAccounts:resolveDuplicateLogin' },
  { path: 'kimiAccounts.setSelected', kind: 'invoke', channel: 'kimiAccounts:setSelected' },
  { path: 'kimiAccounts.submitCode', kind: 'invoke', channel: 'kimiAccounts:submitCode' },
  { path: 'kimiStats.discoverAgents', kind: 'invoke', channel: 'kimiStats:discoverAgents' },
  { path: 'kimiStats.get', kind: 'invoke', channel: 'kimiStats:get' },
  { path: 'kimiStats.getProject', kind: 'invoke', channel: 'kimiStats:getProject' },
  { path: 'listRecentIcons', kind: 'invoke', channel: 'list-recent-icons' },
  { path: 'loadRequestData', kind: 'invoke', channel: 'load-request-data' },
  { path: 'loadTerminalHistory', kind: 'invoke', channel: 'load-terminal-history' },
  { path: 'loadWebhookRequests', kind: 'invoke', channel: 'load-webhook-requests' },
  { path: 'loadWebhookState', kind: 'invoke', channel: 'load-webhook-state' },
  { path: 'localhostPortSetEnabled', kind: 'invoke', channel: 'localhost-port-set-enabled' },
  { path: 'localhostPortsList', kind: 'invoke', channel: 'localhost-ports-list' },
  { path: 'localStats.get', kind: 'invoke', channel: 'localStats:get' },
  { path: 'localStats.getProject', kind: 'invoke', channel: 'localStats:getProject' },
  { path: 'logConsoleEntry', kind: 'invoke', channel: 'log-console-entry' },
  { path: 'logRendererError', kind: 'invoke', channel: 'log-renderer-error' },
  { path: 'maximizeWindow', kind: 'send', channel: 'maximize-window' },
  { path: 'mcpAuth.cancel', kind: 'invoke', channel: 'mcp-auth:cancel' },
  { path: 'mcpAuth.clearGapDismissal', kind: 'invoke', channel: 'mcp-auth:clearGapDismissal' },
  { path: 'mcpAuth.dismissGap', kind: 'invoke', channel: 'mcp-auth:dismissGap' },
  { path: 'mcpAuth.login', kind: 'invoke', channel: 'mcp-auth:login' },
  { path: 'mcpAuth.onAccountGap', kind: 'on', channel: 'mcp-auth:accountGap' },
  { path: 'mcpAuth.onExternalAdd', kind: 'on', channel: 'mcp-auth:externalAdd' },
  { path: 'mcpAuth.onLoginState', kind: 'on', channel: 'mcp-auth:loginState' },
  { path: 'mcpAuth.probe', kind: 'invoke', channel: 'mcp-auth:probe' },
  { path: 'mcpAuth.status', kind: 'invoke', channel: 'mcp-auth:status' },
  { path: 'minimizeWindow', kind: 'send', channel: 'minimize-window' },
  { path: 'movePath', kind: 'invoke', channel: 'move-path' },
  { path: 'onAgentCapabilitiesUpdated', kind: 'on', channel: 'agent-capabilities:updated' },
  { path: 'onAppsCookieReady', kind: 'on', channel: 'apps-cookie-ready' },
  { path: 'onAuthUserChanged', kind: 'on', channel: 'auth-user-changed' },
  { path: 'onBrowserPickRequest', kind: 'on', channel: 'browser-pick-request' },
  { path: 'onChatRealtimeEvent', kind: 'on', channel: 'chat-realtime-event' },
  { path: 'onClaudeUpdateState', kind: 'on', channel: 'claude-update-state' },
  { path: 'onCliInstallState', kind: 'on', channel: 'cli-install-state' },
  { path: 'onCliUpdateState', kind: 'on', channel: 'cli-update-state' },
  { path: 'onCodexSessionId', kind: 'on', channel: 'codex-session-id' },
  { path: 'onDevtoolsNetworkEvent', kind: 'on', channel: 'devtools-network-event' },
  { path: 'onGitCloneProgress', kind: 'on', channel: 'git-clone-progress' },
  { path: 'onMaximizeChange', kind: 'on', channel: 'maximize-change' },
  { path: 'onMirrorActivateTab', kind: 'on', channel: 'mirror-activate-tab' },
  { path: 'onMirrorDeactivateTab', kind: 'on', channel: 'mirror-deactivate-tab' },
  { path: 'onNotesChanged', kind: 'on', channel: 'notes-changed' },
  { path: 'onNotificationClick', kind: 'on', channel: 'notification-click' },
  { path: 'onOpenWithPath', kind: 'on', channel: 'open-with-path' },
  { path: 'onOverlayStateChanged', kind: 'on', channel: 'overlay:state-changed' },
  { path: 'onOverlayTargetClosed', kind: 'on', channel: 'overlay:target-closed' },
  { path: 'onPmMessage', kind: 'on', channel: 'pm:message' },
  { path: 'onPmStream', kind: 'on', channel: 'pm:stream' },
  { path: 'onPmToolRequest', kind: 'on', channel: 'pm:tool-request' },
  { path: 'onPresenceMessage', kind: 'on', channel: 'presence-message' },
  { path: 'onPtyData', kind: 'custom', channel: null },
  { path: 'onPtyDataFor', kind: 'custom', channel: null },
  { path: 'onPtyExit', kind: 'on', channel: 'pty-exit' },
  { path: 'onRelayStateChanged', kind: 'on', channel: 'relay-state-changed' },
  { path: 'onSelectionConsumed', kind: 'on', channel: 'selection-consumed' },
  { path: 'onSessionsChanged', kind: 'on', channel: 'sessions-changed' },
  { path: 'onShareCreateTab', kind: 'on', channel: 'share-create-tab' },
  { path: 'onUpdateStatus', kind: 'on', channel: 'update-status' },
  { path: 'onUsagePinContext', kind: 'on', channel: 'usage-pin:context' },
  { path: 'onUsagePinState', kind: 'on', channel: 'usage-pin:state' },
  { path: 'onUsagePinTheme', kind: 'on', channel: 'usage-pin:theme' },
  { path: 'onWebviewNewWindow', kind: 'on', channel: 'webview-new-window' },
  { path: 'openUsagePin', kind: 'invoke', channel: 'usage-pin:open' },
  { path: 'overlayAttach', kind: 'invoke', channel: 'overlay:attach' },
  { path: 'overlayAttachToFrontmost', kind: 'invoke', channel: 'overlay:attachToFrontmost' },
  { path: 'overlayDetach', kind: 'invoke', channel: 'overlay:detach' },
  { path: 'overlayGetWindows', kind: 'invoke', channel: 'overlay:getWindows' },
  { path: 'overlayHide', kind: 'invoke', channel: 'overlay:hide' },
  { path: 'overlayRegisterKeybind', kind: 'invoke', channel: 'overlay:registerKeybind' },
  { path: 'overlayShow', kind: 'invoke', channel: 'overlay:show' },
  { path: 'overlayUnregisterKeybind', kind: 'invoke', channel: 'overlay:unregisterKeybind' },
  { path: 'pathExists', kind: 'invoke', channel: 'path-exists' },
  { path: 'pickFilesForSkill', kind: 'invoke', channel: 'pick-files-for-skill' },
  { path: 'pmClose', kind: 'invoke', channel: 'pm:close' },
  { path: 'pmGetState', kind: 'invoke', channel: 'pm:get-state' },
  { path: 'pmOpen', kind: 'invoke', channel: 'pm:open' },
  { path: 'pmSaveState', kind: 'invoke', channel: 'pm:save-state' },
  { path: 'pmSendMessage', kind: 'invoke', channel: 'pm:send-message' },
  { path: 'pmSetStopped', kind: 'invoke', channel: 'pm:set-stopped' },
  { path: 'pmToolResult', kind: 'invoke', channel: 'pm:tool-result' },
  { path: 'pmWorkerEvent', kind: 'invoke', channel: 'pm:worker-event' },
  { path: 'presenceSend', kind: 'send', channel: 'presence-send' },
  { path: 'publishMcp', kind: 'invoke', channel: 'publish-mcp' },
  { path: 'publishPackage', kind: 'invoke', channel: 'publish-package' },
  { path: 'publishSkill', kind: 'invoke', channel: 'publish-skill' },
  { path: 'readDirectory', kind: 'invoke', channel: 'read-directory' },
  { path: 'readFile', kind: 'invoke', channel: 'read-file' },
  { path: 'readNote', kind: 'invoke', channel: 'read-note' },
  { path: 'readNoteStat', kind: 'invoke', channel: 'read-note-stat' },
  { path: 'readSkillBundledFile', kind: 'invoke', channel: 'read-skill-bundled-file' },
  { path: 'readSkillFile', kind: 'invoke', channel: 'read-skill-file' },
  { path: 'registerWebviewId', kind: 'invoke', channel: 'register-webview-id' },
  { path: 'relayDisconnect', kind: 'invoke', channel: 'relay-disconnect' },
  { path: 'relayGetStatus', kind: 'invoke', channel: 'relay-get-status' },
  { path: 'removeRecentIcon', kind: 'invoke', channel: 'remove-recent-icon' },
  { path: 'renameFile', kind: 'invoke', channel: 'rename-file' },
  { path: 'renameNote', kind: 'invoke', channel: 'rename-note' },
  { path: 'replaceInFile', kind: 'invoke', channel: 'replace-in-file' },
  { path: 'resizePty', kind: 'invoke', channel: 'resize-pty' },
  { path: 'resolveOpenPath', kind: 'invoke', channel: 'resolve-open-path' },
  { path: 'resumeClaudeSession', kind: 'invoke', channel: 'resume-claude-session' },
  { path: 'resumeCodexSession', kind: 'invoke', channel: 'resume-codex-session' },
  { path: 'resumeGeminiSession', kind: 'invoke', channel: 'resume-gemini-session' },
  { path: 'resumeGrokSession', kind: 'invoke', channel: 'resume-grok-session' },
  { path: 'resumeKimiSession', kind: 'invoke', channel: 'resume-kimi-session' },
  { path: 'saveAllTabs', kind: 'invoke', channel: 'save-all-tabs' },
  { path: 'saveCodexSession', kind: 'invoke', channel: 'save-codex-session' },
  { path: 'saveFolder', kind: 'invoke', channel: 'save-folder' },
  { path: 'saveFoldersForProject', kind: 'invoke', channel: 'save-folders-for-project' },
  { path: 'saveGeminiSession', kind: 'invoke', channel: 'save-gemini-session' },
  { path: 'saveGrokSession', kind: 'invoke', channel: 'save-grok-session' },
  { path: 'saveKimiSession', kind: 'invoke', channel: 'save-kimi-session' },
  { path: 'saveNote', kind: 'invoke', channel: 'save-note' },
  { path: 'savePendingSelections', kind: 'invoke', channel: 'save-pending-selections' },
  { path: 'saveProject', kind: 'invoke', channel: 'save-project' },
  { path: 'saveProjectIconImage', kind: 'invoke', channel: 'save-project-icon-image' },
  { path: 'saveProjectsOrder', kind: 'invoke', channel: 'save-projects-order' },
  { path: 'saveRequestData', kind: 'invoke', channel: 'save-request-data' },
  { path: 'saveSidebarApps', kind: 'invoke', channel: 'save-sidebar-apps' },
  { path: 'saveTabGroups', kind: 'invoke', channel: 'save-tab-groups' },
  { path: 'saveTabGroupsSync', kind: 'custom', channel: null },
  { path: 'saveTabs', kind: 'invoke', channel: 'save-tabs' },
  { path: 'saveTempImage', kind: 'invoke', channel: 'save-temp-image' },
  { path: 'saveTerminal', kind: 'invoke', channel: 'save-terminal' },
  { path: 'saveTerminalHistory', kind: 'invoke', channel: 'save-terminal-history' },
  { path: 'saveUiState', kind: 'invoke', channel: 'save-ui-state' },
  { path: 'saveWebhookState', kind: 'invoke', channel: 'save-webhook-state' },
  { path: 'searchClaudeSessions', kind: 'invoke', channel: 'search-claude-sessions' },
  { path: 'searchFiles', kind: 'invoke', channel: 'search-files' },
  { path: 'seedAppsCookieForWebContents', kind: 'invoke', channel: 'seed-apps-cookie-for-webcontents' },
  { path: 'selectDirectory', kind: 'invoke', channel: 'select-directory' },
  { path: 'sendHttpRequest', kind: 'invoke', channel: 'send-http-request' },
  { path: 'sessionConvert', kind: 'invoke', channel: 'session-convert' },
  { path: 'setAutoUpdate', kind: 'invoke', channel: 'set-auto-update' },
  { path: 'setClaudeCleanupPeriod', kind: 'invoke', channel: 'set-claude-cleanup-period' },
  { path: 'setCodeflowsBadge', kind: 'invoke', channel: 'set-codeflows-badge' },
  { path: 'setMcpRecommendationSkipped', kind: 'invoke', channel: 'set-mcp-recommendation-skipped' },
  { path: 'setMcpVersion', kind: 'invoke', channel: 'set-mcp-version' },
  { path: 'setMobileEnabled', kind: 'invoke', channel: 'set-mobile-enabled' },
  { path: 'setSetting', kind: 'invoke', channel: 'set-setting' },
  { path: 'setUpdateChannel', kind: 'invoke', channel: 'set-update-channel' },
  { path: 'setUsagePinContext', kind: 'invoke', channel: 'usage-pin:set-context' },
  { path: 'setUsagePinTheme', kind: 'invoke', channel: 'usage-pin:set-theme' },
  { path: 'setWindowBackground', kind: 'invoke', channel: 'set-window-background' },
  { path: 'share.canEdit', kind: 'invoke', channel: 'share:canEdit' },
  { path: 'share.canView', kind: 'invoke', channel: 'share:canView' },
  { path: 'share.captureSnapshot', kind: 'invoke', channel: 'share:captureSnapshot' },
  { path: 'share.hide', kind: 'invoke', channel: 'share:hide' },
  { path: 'share.inbox', kind: 'invoke', channel: 'share:inbox' },
  { path: 'share.liveTargets', kind: 'invoke', channel: 'share:liveTargets' },
  { path: 'share.markViewed', kind: 'invoke', channel: 'share:markViewed' },
  { path: 'share.registerPtyMap', kind: 'invoke', channel: 'share:registerPtyMap' },
  { path: 'share.revoke', kind: 'invoke', channel: 'share:revoke' },
  { path: 'share.searchPeople', kind: 'invoke', channel: 'share:searchPeople' },
  { path: 'share.send', kind: 'invoke', channel: 'share:send' },
  { path: 'share.sent', kind: 'invoke', channel: 'share:sent' },
  { path: 'share.setPermission', kind: 'invoke', channel: 'share:setPermission' },
  { path: 'share.target', kind: 'invoke', channel: 'share:target' },
  { path: 'shareMcp', kind: 'invoke', channel: 'share-mcp' },
  { path: 'shareSkill', kind: 'invoke', channel: 'share-skill' },
  { path: 'showInFolder', kind: 'invoke', channel: 'show-in-folder' },
  { path: 'showNotification', kind: 'invoke', channel: 'show-notification' },
  { path: 'startUpdate', kind: 'invoke', channel: 'start-update' },
  { path: 'submitBugReport', kind: 'invoke', channel: 'submit-bug-report' },
  { path: 'supabaseEdgeFunction', kind: 'invoke', channel: 'supabase-edge-function' },
  { path: 'supabaseGetUserId', kind: 'invoke', channel: 'supabase-get-user-id' },
  { path: 'supabaseRealtimeBroadcast', kind: 'invoke', channel: 'supabase-realtime-broadcast' },
  { path: 'supabaseRealtimeSubscribe', kind: 'invoke', channel: 'supabase-realtime-subscribe' },
  { path: 'supabaseRealtimeUnsubscribe', kind: 'invoke', channel: 'supabase-realtime-unsubscribe' },
  { path: 'supabaseRpc', kind: 'invoke', channel: 'supabase-rpc' },
  { path: 'supabaseStorageUpload', kind: 'invoke', channel: 'supabase-storage-upload' },
  { path: 'syncMcpAll', kind: 'invoke', channel: 'sync-mcp-all' },
  { path: 'takeoverAgent', kind: 'invoke', channel: 'takeover-agent' },
  { path: 'takeScreenshot', kind: 'invoke', channel: 'take-screenshot' },
  { path: 'trackRegistryInstall', kind: 'invoke', channel: 'track-registry-install' },
  { path: 'trashFile', kind: 'invoke', channel: 'trash-file' },
  { path: 'uninstallMcp', kind: 'invoke', channel: 'uninstall-mcp' },
  { path: 'uninstallPackage', kind: 'invoke', channel: 'uninstall-package' },
  { path: 'uninstallSkill', kind: 'invoke', channel: 'uninstall-skill' },
  { path: 'unregisterWebviewId', kind: 'invoke', channel: 'unregister-webview-id' },
  { path: 'unwatchConsumed', kind: 'invoke', channel: 'unwatch-consumed' },
  { path: 'unwatchNotesDirectory', kind: 'invoke', channel: 'unwatch-notes-directory' },
  { path: 'unwatchSessionsDirectory', kind: 'invoke', channel: 'unwatch-sessions-directory' },
  { path: 'updateSkillFiles', kind: 'invoke', channel: 'update-skill-files' },
  { path: 'usageSync.getRange', kind: 'invoke', channel: 'usageSync:getRange' },
  { path: 'usageSync.getStatus', kind: 'invoke', channel: 'usageSync:getStatus' },
  { path: 'usageSync.syncNow', kind: 'invoke', channel: 'usageSync:syncNow' },
  { path: 'useRecentIcon', kind: 'invoke', channel: 'use-recent-icon' },
  { path: 'voiceCancel', kind: 'invoke', channel: 'voice:cancel' },
  { path: 'voiceRequestMicAccess', kind: 'invoke', channel: 'voice:request-mic-access' },
  { path: 'voiceTranscribe', kind: 'invoke', channel: 'voice:transcribe' },
  { path: 'voiceTransform', kind: 'invoke', channel: 'voice:transform' },
  { path: 'watchConsumed', kind: 'invoke', channel: 'watch-consumed' },
  { path: 'watchNotesDirectory', kind: 'invoke', channel: 'watch-notes-directory' },
  { path: 'watchSessionsDirectory', kind: 'invoke', channel: 'watch-sessions-directory' },
  { path: 'writeFile', kind: 'invoke', channel: 'write-file' },
  { path: 'writeSkillFile', kind: 'invoke', channel: 'write-skill-file' },
  { path: 'writeToPty', kind: 'invoke', channel: 'write-to-pty' },
]
